// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UXX-","colMin":"styles_colMin__1G3g7"};